import { render, staticRenderFns } from "./ColapsableTodosTable.vue?vue&type=template&id=13159aa9&scoped=true"
import script from "./ColapsableTodosTable.vue?vue&type=script&lang=ts"
export * from "./ColapsableTodosTable.vue?vue&type=script&lang=ts"
import style0 from "./ColapsableTodosTable.vue?vue&type=style&index=0&id=13159aa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13159aa9",
  null
  
)

export default component.exports